"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var okta_auth_js_1 = require("@okta/okta-auth-js");
var gaf_okta_abstract_1 = require("../gaf-okta.abstract");
var GafOktaBrowser = /** @class */ (function (_super) {
    __extends(GafOktaBrowser, _super);
    //#endregion
    function GafOktaBrowser(config, callbacks, tokenManager, storage, windowLocation) {
        var _this_1 = _super.call(this, config, callbacks, tokenManager, storage, windowLocation) || this;
        _this_1.config = config;
        _this_1.callbacks = callbacks;
        _this_1.tokenManager = tokenManager;
        _this_1.storage = storage;
        _this_1.windowLocation = windowLocation;
        try {
            if (!okta_auth_js_1.OktaAuth.features.isPKCESupported()) {
                config.pkce = false;
            }
        }
        catch (error) {
            config.pkce = false;
        }
        _this_1._oktaAuth = _this_1.createWebAuth();
        _this_1._setup.configureEventListener();
        return _this_1;
    }
    //#region protected functions
    GafOktaBrowser.prototype.createWebAuth = function () {
        return this._setup.createWebAuth(this.config, this.isSingleAudience());
    };
    /**
     * Renew the ID token
     * @param promise Promise resolve and reject functions to call
     */
    GafOktaBrowser.prototype.renewIdToken = function (promise) {
        var _this_1 = this;
        var promiseNew = this.getStandardPromiseFunction(promise);
        this._oktaAuth.tokenManager
            .get('idToken')
            .then(function (idToken) {
            if (idToken) {
                _this_1._oktaAuth.tokenManager
                    .renew('idToken')
                    .then(function (newIdToken) {
                    _this_1._oktaAuth.tokenManager
                        .renew('accessToken')
                        .then(function (accessToken) {
                        var res = {
                            tokens: {
                                accessToken: accessToken,
                                idToken: newIdToken,
                            },
                        };
                        _this_1.checkSessionCallback(undefined, res, promiseNew);
                    })
                        .catch(function (err) {
                        _this_1.checkSessionCallback(err, undefined, promiseNew);
                    });
                })
                    .catch(function (err) {
                    _this_1.checkSessionCallback(err, undefined, promiseNew);
                });
            }
        })
            .catch(function (err) {
            _this_1.checkSessionCallback(err, undefined, promiseNew);
        });
    };
    GafOktaBrowser.prototype.renewAccessToken = function (promise) {
        var _this_1 = this;
        var promiseNew = this.getStandardPromiseFunction(promise);
        this._oktaAuth.tokenManager
            .get('idToken')
            .then(function (idToken) {
            if (idToken) {
                _this_1._oktaAuth.tokenManager
                    .renew('accessToken')
                    .then(function (accessToken) {
                    var res = {
                        tokens: {
                            accessToken: accessToken,
                            idToken: idToken,
                        },
                    };
                    _this_1.checkSessionCallback(undefined, res, promiseNew);
                })
                    .catch(function (err) {
                    _this_1.checkSessionCallback(err, undefined, promiseNew);
                });
            }
        })
            .catch(function (err) {
            _this_1.checkSessionCallback(err, undefined, promiseNew);
        });
    };
    GafOktaBrowser.prototype.getRenewToken = function (promise) {
        // return new Promise<string>((resolve, reject)) => {
        var promiseNew = this.getStandardPromiseFunction(promise);
        var scope = [];
        scope = this.config.scopes;
        var idp = this.config.idp;
        var accessToken = this.storage && this.storage.info ? this.storage.info.accessToken : undefined;
        var options = {
            responseType: ['token', 'id_token'],
            accessToken: accessToken,
            scopes: scope,
        };
        if (idp) {
            options.idp = idp;
        }
        var oktaauth = this._oktaAuth;
        var _this = this;
        this._oktaAuth.token
            .renew(options)
            .then(function (tokens) {
            var newTokens = Array.isArray(tokens) ? tokens : [tokens];
            for (var _i = 0, newTokens_1 = newTokens; _i < newTokens_1.length; _i++) {
                var token = newTokens_1[_i];
                if (token.idToken) {
                    oktaauth.tokenManager.add('idToken', token);
                }
                else if (token.accessToken) {
                    oktaauth.tokenManager.add('accessToken', token);
                }
            }
            _this.checkSessionCallback(undefined, newTokens, promiseNew);
        })
            .catch(function (err) {
            _this.checkSessionCallback(err, undefined, promiseNew);
        });
    };
    //#endregion
    //#region Public Interface
    GafOktaBrowser.prototype.login = function () {
        this.clearSessionInfo(); // clear the session just in case.
        // if child mode, send back to the parent.  If parent mode, go to authorize
        if (this.isChildMode()) {
            var redirectUri = this.getChildRedirectUri();
            if (redirectUri !== undefined) {
                this.windowLocation.assign(this.getChildRedirectUri());
            }
        }
        else {
            var scope = [];
            scope = this.config.scopes;
            var idp = this.config.idp;
            var responseType = 'code';
            try {
                if (!this.config.pkce || !okta_auth_js_1.OktaAuth.features.isPKCESupported()) {
                    responseType = ['token', 'id_token'];
                }
            }
            catch (error) {
                responseType = ['token', 'id_token'];
            }
            var options = {
                responseType: responseType,
                scopes: ['openid', 'profile', 'email'].concat(scope),
            };
            if (idp) {
                options.idp = idp;
            }
            this._oktaAuth.token.getWithRedirect(options);
        }
    };
    /**
     * Logout and issue logout command
     */
    GafOktaBrowser.prototype.logout = function (logoutUrl) {
        this.clearSessionInfo();
        if (typeof this.callbacks.onAuthenticationChanged === 'function') {
            this.callbacks.onAuthenticationChanged(false);
        }
        // if this is not child mode, then you need to log out from okta as well
        if (!this.isChildMode() && this.config.postLogoutRedirectUri !== undefined) {
            this._oktaAuth.signOut({
                revokeAccessToken: false,
                postLogoutRedirectUri: logoutUrl ? logoutUrl : this.config.postLogoutRedirectUri,
            });
        }
    };
    /**
     * Get Access Token for a given url
     * @param url The url we are attempting to get the access token for
     */
    GafOktaBrowser.prototype.getAccessToken = function (url) {
        var _this_1 = this;
        var singleAudience = !this.areScopesProvided() || this.isSingleAudience();
        if (singleAudience) {
            return _super.prototype.getAccessToken.call(this);
        }
        else {
            // multiple audience
            return new Promise(function (resolve, reject) {
                _this_1._initialRenewIdTokenPromise.then(function () {
                    var key = _this_1.callbacks.getScopesKeyFromUrl(url);
                    if (key === undefined || key === null || key === '') {
                        if (typeof _this_1.callbacks.onRenewError === 'function') {
                            _this_1.callbacks.onRenewError('Audience String Is Missing');
                        }
                        resolve();
                    }
                    else {
                        // let's attempt to get the token from cache... if we can, and it's not expired, just use it
                        var item = _this_1.tokenManager.get(key, _this_1.config.accessTokenThreshold);
                        // if we have a token, use it
                        if (item !== undefined) {
                            resolve(item.value);
                        }
                        else {
                            // find the scopes for the given key from the array of scope definitions
                            var scopeArray = _this_1.config.scopes;
                            var scopeItem = scopeArray.find(function (find) {
                                return find.key === key;
                            });
                            // if we did not find any, then we have an error
                            if (scopeItem !== undefined) {
                                if (typeof _this_1.callbacks.onRenewError === 'function') {
                                    _this_1.callbacks.onRenewError("Could not find scopes for key: " + key);
                                }
                                // call checksession to get the scopes for the key.
                            }
                            else {
                                _this_1._oktaAuth.token
                                    .getWithoutPrompt()
                                    .then(function (tokens) {
                                    var newTokens = Array.isArray(tokens) ? tokens : [tokens];
                                    for (var _i = 0, newTokens_2 = newTokens; _i < newTokens_2.length; _i++) {
                                        var token = newTokens_2[_i];
                                        if (token.idToken) {
                                            _this_1._oktaAuth.tokenManager.add('idToken', token);
                                        }
                                        else if (token.accessToken) {
                                            _this_1._oktaAuth.tokenManager.add('accessToken', token);
                                        }
                                    }
                                    _this_1.tokenManager.set(key, newTokens[0].accessToken);
                                    resolve(newTokens[0].accessToken);
                                })
                                    .catch(function (err) {
                                    // we had an error getting the scopes
                                    if (typeof _this_1.callbacks.onRenewError === 'function') {
                                        _this_1.callbacks.onRenewError(err);
                                    }
                                    resolve();
                                });
                            }
                        }
                    }
                });
            });
        }
    };
    GafOktaBrowser.prototype.handleAuthentication = function () {
        var _this_1 = this;
        return new Promise(function (resolve, reject) {
            var authResult;
            _this_1._oktaAuth.token
                .parseFromUrl()
                .then(function (tokens) {
                authResult = tokens;
                var _a = tokens.tokens || {}, accessToken = _a.accessToken, idToken = _a.idToken;
                if (idToken) {
                    _this_1._oktaAuth.tokenManager.add('idToken', idToken);
                }
                if (accessToken) {
                    _this_1._oktaAuth.tokenManager.add('accessToken', accessToken);
                }
                var promise = {
                    resolve: function () {
                        if (authResult) {
                            _this_1.windowLocation.hash = '';
                            _this_1.setAuthSession(authResult);
                            if (typeof _this_1.callbacks.onAuthenticationChanged === 'function') {
                                _this_1.callbacks.onAuthenticationChanged(true);
                            }
                            resolve(true);
                        }
                        else if (authResult === undefined || authResult === null) {
                            resolve(true); // no hash
                        }
                    },
                    reject: function (err) {
                        reject(err);
                    },
                };
                _this_1.checkSessionCallback(undefined, authResult, promise);
            })
                .catch(function (err) {
                var promise = {
                    resolve: function () {
                        resolve(true);
                    },
                    reject: function () {
                        reject(err);
                    },
                };
                _this_1.checkSessionCallback(err, undefined, promise);
            });
        });
    };
    return GafOktaBrowser;
}(gaf_okta_abstract_1.GafOkta));
exports.GafOktaBrowser = GafOktaBrowser;
